<script setup>
const props = defineProps({
  label: String
})
</script>

<template>
  <div :class="[
      'px-1',
      label ? 'pt-5 pb-1' : 'py-1'
  ]">
    <div
        v-if="label"
        class="mb-1.5 px-2 text-[11px] font-bold uppercase tracking-tight">
      {{label}}
    </div>
    <slot />
  </div>
</template>

<style scoped>

</style>
